import { createRouter, createWebHistory } from 'vue-router'

import Cabinet from './components/Cabinet.vue'
import Catalog from './components/catalog/Catalog.vue'
import EditModule from './components/modules/EditModule.vue'
import EditPlan from './components/plans/EditPlan.vue'
import EditSphere from './components/spheres/EditSphere.vue'
import Login from './components/Login.vue'
import Modules from './components/modules/Modules.vue'
import NewModule from './components/modules/NewModule.vue'
import NewPlan from './components/plans/NewPlan.vue'
import NewSphere from './components/spheres/NewSphere.vue'
import NewUser from './components/users/NewUser.vue'
import Plan from './components/plans/Plan.vue'
import PlanModule from './components/plans/PlanModule.vue'
import PlanModules from './components/plans/PlanModules.vue'
import PlansAdmin from './components/plans/PlansAdmin.vue'
import Plans from './components/plans/Plans.vue'
import PurchaseCancel from './components/plans/PurchaseCancel.vue'
import PurchaseSuccess from './components/plans/PurchaseSuccess.vue'
import Spheres from './components/spheres/Spheres.vue'
import Briefs from './components/briefs/Briefs.vue'
import User from './components/users/User.vue'
import Users from './components/users/Users.vue'
import Home from './components/Home.vue'

const routes = [
    // { path: '/', component: Home },
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    // Registration moved to the SuperQR cabinet login page; keep the path as a
    // graceful redirect for stale links/bookmarks.
    { path: '/register', redirect: '/login' },
    {
        path: '/purchase/success',
        component: PurchaseSuccess,
        meta: {
            isCabinet: true,
            roles: ['user', 'admin']
        }
    },
    {
        path: '/purchase/cancel',
        component: PurchaseCancel,
        meta: {
            isCabinet: true,
            roles: ['user', 'admin']
        }
    },
    {
        path: '/cabinet',
        component: Cabinet,
        meta: {
            isCabinet: true,
            roles: ['admin', 'user']
        }
    },
    {
        path: '/plans',
        children: [
            {
                path: '',
                component: PlansAdmin,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/plans/:id',
                component: EditPlan,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/plans/:id/modules',
                component: PlanModules,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/plans/:id/modules/:slug',
                component: PlanModule,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/plans/new',
                component: NewPlan,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/plans-table',
                children: [
                    {
                        path: '',
                        component: Plans,
                        meta: {
                            isCabinet: true,
                            roles: ['user']
                        }
                    },
                    {
                        path: '/plans/buy/:id',
                        component: Plan,
                        meta: {
                            isCabinet: true,
                            roles: ['user']
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/modules',
        children: [
            {
                path: '',
                component: Modules,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/modules/new',
                component: NewModule,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/modules/:id',
                component: EditModule,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
        ]
    },
    {
        path: '/users',
        children: [
            {
                path: '',
                component: Users,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/users/new',
                component: NewUser,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/users/:id',
                component: User,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            }
        ]
    },
    {
        path: '/catalog',
        component: Catalog,
        meta: {
            isCabinet: true,
            roles: ['admin']
        }
    },
    {
        path: '/briefs',
        component: Briefs,
        meta: {
            isCabinet: true,
            roles: ['admin']
        }
    },
    {
        path: '/spheres',
        children: [
            {
                path: '',
                component: Spheres,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/spheres/new',
                component: NewSphere,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            },
            {
                path: '/spheres/:id',
                component: EditSphere,
                meta: {
                    isCabinet: true,
                    roles: ['admin']
                }
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router